module.exports = __webpack_public_path__ + "img/icon_item_active.e33348cb.png";